import { ApiResult, apiUrl } from '../../../api';
import {
  Company,
  CompanyDuplicate,
  CreateExternalCompanyRequest,
  UpdateInternalCompanyRequest,
} from '../../../models/Company';
import { CompanyId } from '../../../models/Types';
import { getAccessToken } from '../../../store/authEffect';
import fetchWithRetry from '../../../util/fetchWithRetry';

export const apiCheckCompanyDuplicate: (
  values: CompanyDuplicate
) => Promise<ApiResult<Company[]>> = async (values) => {
  const keysArr = Object.keys(values);
  const valsArr = Object.values(values);
  const validationString = keysArr
    .map((key, idx) => `${key}=${valsArr[idx]}`)
    .join('&');
  const result = await fetchWithRetry(
    `${apiUrl}/contact/Company/validation?${validationString}`,
    {
      headers: {
        Authorization: `Bearer ${await getAccessToken()}`,
        'Content-Type': 'application/json',
      },
      method: 'GET',
    }
  );

  const data =
    result.status >= 200 && result.status < 300 ? await result.json() : null;
  return {
    result,
    data,
  };
};

export const apiCreateExternalCompany: (
  value: CreateExternalCompanyRequest
) => Promise<ApiResult<Company>> = async (value) => {
  const result = await fetchWithRetry(
    `${apiUrl}/contact/Company/externalCompany`,
    {
      headers: {
        Authorization: `Bearer ${await getAccessToken()}`,
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify({ ...value }),
    }
  );

  const data =
    result.status >= 200 && result.status < 300 ? await result.json() : null;
  return {
    result,
    data,
  };
};

export const apiFetchCompany: (
  companyId: CompanyId
) => Promise<ApiResult<Company>> = async (companyId) => {
  const result = await fetchWithRetry(
    `${apiUrl}/contact/company/${companyId}`,
    {
      headers: {
        Authorization: `Bearer ${await getAccessToken()}`,
        'Content-Type': 'application/json',
      },
      method: 'GET',
    }
  );
  const data =
    result.status >= 200 && result.status < 300 ? await result.json() : null;
  return {
    result,
    data,
  };
};

export const apiUpdateInternalCompany: (
  companyId: CompanyId,
  patch: UpdateInternalCompanyRequest,
  rowVersion: string
) => Promise<ApiResult<Company>> = async (companyId, patch, rowVersion) => {
  const result = await fetchWithRetry(
    `${apiUrl}/contact/Company/internalCompany/${companyId}`,
    {
      method: 'PATCH',
      headers: {
        Authorization: `Bearer ${await getAccessToken()}`,
        'Content-Type': 'application/merge-patch+json',
      },
      body: JSON.stringify({
        ...patch,
        rowVersion,
      }),
    }
  );
  const data =
    result.status >= 200 && result.status < 300 ? await result.json() : null;
  return {
    result,
    data,
  };
};
